(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dripdrop-home-trusted"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.dd-trusted-slider').forEach((root) => {
      if (root.dataset.ddTrustedInitialized === 'true') return;
      root.dataset.ddTrustedInitialized = 'true';

      root.querySelectorAll('[data-dd-trusted-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const media = button.closest('.dd-trusted-slider__media');
          const video = media?.querySelector('[data-dd-trusted-video]');
          if (!media || !video) return;

          if (media.classList.contains('is-playing')) {
            video.pause();
            media.classList.remove('is-playing');
            return;
          }

          root.querySelectorAll('.dd-trusted-slider__media.is-playing').forEach((item) => {
            item.classList.remove('is-playing');
            const activeVideo = item.querySelector('[data-dd-trusted-video]');
            activeVideo?.pause();
          });

          media.classList.add('is-playing');
          video.play().catch(() => {});
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dripdrop-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.dd-site-header[data-dd-header]').forEach((root) => {
      if (root.dataset.ddHeaderInitialized === 'true') return;
      root.dataset.ddHeaderInitialized = 'true';

      const main = root.querySelector('[data-dd-header-main]');
      const announcementTrack = root.querySelector('[data-dd-announcement-track]');
      const announcementSlides = Array.from(root.querySelectorAll('[data-dd-announcement-slide]'));
      const drawer = root.querySelector('[data-dd-drawer]');
      const searchDialog = root.querySelector('[data-dd-search-dialog]');

      if (main) {
        const syncScrolled = () => {
          main.classList.toggle('is-scrolled', window.scrollY > 12);
        };
        syncScrolled();
        window.addEventListener('scroll', syncScrolled, { passive: true });
      }

      if (announcementTrack && announcementSlides.length > 1 && announcementTrack.hasAttribute('data-rotate')) {
        let index = 0;
        window.setInterval(() => {
          announcementSlides[index].classList.remove('is-active');
          index = (index + 1) % announcementSlides.length;
          announcementSlides[index].classList.add('is-active');
        }, 7000);
      }

      root.querySelectorAll('[data-dd-drawer-open]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
        });
      });

      root.querySelectorAll('[data-dd-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.remove('is-open');
          document.documentElement.style.overflow = '';
        });
      });

      root.querySelectorAll('[data-dd-search-open]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!searchDialog?.showModal) return;
          searchDialog.showModal();
        });
      });

      root.querySelectorAll('[data-dd-search-close]').forEach((button) => {
        button.addEventListener('click', () => {
          searchDialog?.close();
        });
      });

      searchDialog?.addEventListener('click', (event) => {
        const rect = searchDialog.getBoundingClientRect();
        const inside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;

        if (!inside) {
          searchDialog.close();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
